<template>
    <div class="top">
        <Table stripe :columns="columns" :data="rankingList.body"></Table>
        <div class="page-box">
                <Page
                        :total="rankingList.page.count"
                        :page-size="rankingList.page.page_size"
                        @on-change="change_page"
                        show-total
                />
            </div>
             <!-- 代码查看框 -->
            <Modal
                :scrollable="true"
                v-model="showModal"
                title="查看代码"
                width="800"
                >
                <div id='doc' style="overflow:scroll;height:500px;"></div>
            </Modal>
    </div>
</template>
<script>
    import {mapActions,mapState} from 'vuex'
    import moment from 'moment'
    import {authApi} from '@/api/base.js'
    import cookie from "vue-cookies";
    import {nbNotebook} from "../../../../assets/js/nbv"
    import { saveAs } from 'file-saver';
    export default {
        props:{
            callBackActive:{
                type:Function,
                required:true,
            },
            isEval:{
                type:Boolean,
                required:true,
            },
            procStatus:{
                type:Number,
                required:true,
            },
        },
        data () {
            return {
                showModal:false,
                id:0,
                page_num: 1,
                page_size: 24,
                rankingList:{body:[],page:{page_num:0,page_size:0,count:0}},
                columns: [
                    {
                        title: '排名',
                        key: 'rank',
                    },
                    {
                        title: '团队',
                        key: 'team_name',
                        // render:(h,params)=>{
                        //     if(params.row.is_open == 1){
                        //         return h('div',[
                        //             h('a',{
                        //                 style:{},
                        //                 on:{
                        //                     click:()=>{
                        //                         this.callBackActive('Public',params.row.code_info.code_uuid);
                        //                     }
                        //                 }
                        //             },params.row.team_name)
                        //         ])
                        //     }else{
                        //         return h('div',[
                        //             h('p',{
                        //                 style:{},
                        //             },params.row.name)
                        //         ])
                        //     }
                        // }
                    },
                    {
                        title: '分数',
                        key: 'score'
                    },
                    {
                        title:'提交次数',
                        key:'submit_count',
                    },{
                        title:'提交时间',
                        key:'submit_time',
                        render: (h, params) => {
                            return h('div', [
                                h('span', {
                                }, moment(params.row.submit_time).format('YYYY-MM-DD HH:mm:ss')),
                            ]);
                        }
                    },{
                        title:"操作",
                        key:'action',
                        width:150,
                        renderHeader:(h,params)=>{
                            return h('div',{style:{
                                display:(this.user_info.sysRoles && this.user_info.sysRoles[0].code == 'teacher') ? "inline-block" : "none"
                            }})
                        },
                        render:(h,params)=>{
                            return h('div',[
                                h('a', {
                                    style: {
                                        marginRight: '5px',
                                        color:'#029ff6',
                                        display:(this.user_info.sysRoles && this.user_info.sysRoles[0].code == 'teacher') ? "inline-block" : "none"
                                    },
                                    on: {
                                        click: () => {
                                            this.showCode(params.row);
                                        }
                                    }
                                }, '查看'),
                                h('a', {
                                    style: {
                                        marginRight: '5px',
                                        color:'#029ff6',
                                        display:(this.user_info.sysRoles && this.user_info.sysRoles[0].code == 'teacher') ? "inline-block" : "none"
                                    },
                                    on: {
                                        click: () => {
                                            this.exportUserCode(params.row);
                                        }
                                    }
                                }, '导出代码')
                            ])
                        }
                    },{
                        width:100,
                        renderHeader:(h,params) =>{
                            return h('Button',{
                               style:{
                                   display:(this.isEval && this.rankingList.body.length > 0) || (!this.isEval && this.procStatus == 5 && this.rankingList.body.length > 0) ? "inline-block" : "none"
                               },
                               on:{
                                   click:()=>{
                                       console.log(params)
                                       this.export()
                                   }
                               } 
                            },"导出")
                        }
                    }
                ],
            }
        },
        methods:{
            ...mapActions({
                getRankingList:'contestCommunity/getRankingList',
                getUserCode:'contestCommunity/getUserCode',
                // exportExcel:'contestCommunity/exportExcel'
            }),
            // 查看用户代码
            showCode(param){
                let _this = this;
                this.getUserCode({
                    data:{
                        compet_id:this.id,
                        code_uuid:param.code_info.code_uuid
                    },
                    callback:res=>{
                            _this.ipynb = JSON.parse(res.content);
                            let doc = document.getElementById("doc");
                            nbNotebook.render(this.ipynb,doc);
                            this.showModal = true;
                        },
                        error:msg=>{
                            _this.$Message.error(msg);
                        }
                });
            },
            // 导出用户代码
            exportUserCode(param){
                let _this = this;
                this.getUserCode({
                    data:{
                        compet_id:this.id,
                        code_uuid:param.code_info.code_uuid
                    },
                    callback:res=>{
                        var blob = new Blob([res.content], { type: "" });
                        saveAs(blob, param.leader_name+".ipynb");
                    },
                    error:msg=>{
                        _this.$Message.error(msg);
                    }
                });
            },
            // 导出排行榜excel
            export(){
                let _this = this;
                var openUrl = authApi+"api-course//tm/ccompetjoin/"+_this.id+"/rank/export?access_token="+cookie.get('session');
                window.open(openUrl);
                // this.exportExcel({
                //     compet_id:_this.id,
                //     callback:res=>{
                //         _this.$Message.error("下载任务成功");
                //     },
                //     error:msg=>{
                //         _this.$Message.error(msg);
                //     }
                // });
            },
            // 分页
            change_page(page){
                this.page_num = page;
                this.getList();
            },
            // 获取列表
            getList(){
                let _this = this;
                this.getRankingList({
                    id:_this.id,
                    data:{
                        page_num:_this.page_num,
                        page_size:_this.page_size,
                    },
                    callback:res=>{
                        _this.rankingList = res;
                    },
                    error:msg=>{
                        _this.$Message.error(msg);
                    }
                })
            }
        },
        created() {
            let _this = this;
            _this.id = this.$route.params.id;
            if (_this.id > 0){
                // 获取排行榜信息
                this.getList();
            }
        },
        computed: {
            ...mapState({
                user_info: state => state.loginState.user_info,
            })
        },
    }
</script>
<style scoped>
    .top{

    }
</style>